module.exports = __webpack_public_path__ + "img/NoimageIcon.c66fb078.svg";